import { Modal, Typography } from "antd";

const { Title } = Typography;

export default function ContactBulkImport(props) {
    const { openBulkImport, setOpenBulkImport } = props;
    return (
        <Modal
            title={
                <Title level={3} className="modalTitle" strong>
                    Bulk Import
                </Title>
            }
            open={openBulkImport}
            onCancel={() => setOpenBulkImport(false)}
            footer={null}
            width={500}
            centered
            className="contactListModal"
        >
            <div style={{ padding: 24, textAlign: 'center' }}>Feature coming soon</div>
        </Modal>
    );
}